import {
  GoogleAnalyticsService,
  VWOAnalyticsService,
  VWOEvents,
} from '@grupoboticario/barril-del-chavo'
import { ecommerceEvent, ProductItem } from '@grupoboticario/tag-book-sellout'

interface EventsParameters {
  productSku?: string
  muted?: boolean
  cycle?: string
}

interface BaseEventParameters extends EventsParameters {
  cd_interaction_detail: string
}

const baseEvent = ({ cd_interaction_detail, productSku, cycle }: BaseEventParameters) => {
  const eventData = {
    event: 'analytics-event',
    event_parameters: {
      event_name: 'interaction_vitrines',
      cd_interaction_detail,
      cd_section: 'vitrine-home-videos-piloto',
      item_id: productSku,
      cd_ciclo: cycle,
    },
  }

  if (!productSku) {
    delete eventData.event_parameters.item_id
  }

  if (!cycle) {
    delete eventData.event_parameters.cd_ciclo
  }

  VWOAnalyticsService.dispatchVWOEvent(VWOEvents.INTERACTION_WITH_VIDEO_SHOWCASE, {
    actiontype: cd_interaction_detail,
  })
  GoogleAnalyticsService.event(eventData)
}

export const trackVideoClick = ({ productSku, cycle }: EventsParameters) => {
  baseEvent({ cd_interaction_detail: 'click:ver-video', productSku, cycle })
}

export const trackCloseVideo = ({ productSku, cycle }: EventsParameters) => {
  baseEvent({ cd_interaction_detail: 'click:fechar-video', productSku, cycle })
}

export const trackSeeDetails = ({ productSku, cycle }: EventsParameters) => {
  baseEvent({ cd_interaction_detail: 'click:ver-detalhes', productSku, cycle })
}

export const trackVolume = ({ productSku, muted, cycle }: EventsParameters) => {
  baseEvent({
    cd_interaction_detail: `click:volume:${muted ? 'desmutar' : 'mutar'}`,
    productSku,
    cycle,
  })
}

export const trackSwipeBack = ({ cycle }: EventsParameters) => {
  baseEvent({ cd_interaction_detail: 'swipe:anterior', cycle })
}

export const trackSwipeNext = ({ cycle }: EventsParameters) => {
  baseEvent({ cd_interaction_detail: 'swipe:proximo', cycle })
}

export const trackProductList = ({ skuList }: { skuList: Partial<ProductItem>[] }) => {
  ecommerceEvent({
    eventName: 'view_item_list',
    products: skuList,
    parameters: {
      item_list_id: 'vitrine-home-videos-piloto',
      item_list_name: 'Vitrine piloto vídeos',
    },
  })
}
